import React from "react";
import "../css/Loading.css";

const Loading = ({ msg }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">{msg || "Ładowanie..."}</p>
      </div>
    </div>
  );
};

export default Loading;
